/* Publish by EComposer at 2024-06-11 12:13:48*/
(function(){
    const Func = (function() {
        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gneuq4v5u7l"]=  window.__ectimmers["ecom-gneuq4v5u7l"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

    });
    
        document.querySelectorAll('.ecom-gneuq4v5u7l').forEach(function(el){
            Func.call({$el: el, id: 'ecom-gneuq4v5u7l', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-aqxz7vq9px8').forEach(function(el){
            Func.call({$el: el, id: 'ecom-aqxz7vq9px8', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-vzxjriurker').forEach(function(el){
            Func.call({$el: el, id: 'ecom-vzxjriurker', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-pc8pbv0meb').forEach(function(el){
            Func.call({$el: el, id: 'ecom-pc8pbv0meb', settings: {},isLive: true});
        });
    

})();

(function(){
    const Func = (function() {
        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-t86xi0vnlx"]=  window.__ectimmers["ecom-t86xi0vnlx"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

    });
    
        document.querySelectorAll('.ecom-t86xi0vnlx').forEach(function(el){
            Func.call({$el: el, id: 'ecom-t86xi0vnlx', settings: {"link":"none","lightbox":"no"},isLive: true});
        });
    
        document.querySelectorAll('.ecom-47ie0pguf7e').forEach(function(el){
            Func.call({$el: el, id: 'ecom-47ie0pguf7e', settings: {"link":"none","lightbox":"no"},isLive: true});
        });
    
        document.querySelectorAll('.ecom-whydnn67tkb').forEach(function(el){
            Func.call({$el: el, id: 'ecom-whydnn67tkb', settings: {"link":"none","lightbox":"no"},isLive: true});
        });
    

})();

;try{

} catch(error){console.error(error);}